var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreestandingProductsGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 102",
    style: {
      enableBackground: "new 0 0 150 102"
    },
    xmlSpace: "preserve",
    width: "120px",
    height: "120px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000124150001621509197340000006043641379426025380_);}\n\t.st1{fill:url(#Rectangle_120_00000045612725536793588420000007906074986519346851_);}\n\t.st2{clip-path:url(#SVGID_00000083789105468386785880000014854457484040728495_);}\n\t.st3{fill:url(#Rectangle_121_00000038389220579422999190000013520094395677191316_);}\n\t.st4{clip-path:url(#SVGID_00000020359114668264379810000000411001094413036937_);}\n\t.st5{fill:url(#Rectangle_122_00000008142868441650820710000006177711024236465849_);}\n\t.st6{clip-path:url(#SVGID_00000117651764080765751740000002495085025088399501_);}\n\t.st7{fill:url(#Rectangle_123_00000095307719160519198920000000174572794400028809_);}\n\t.st8{clip-path:url(#SVGID_00000116928755543469112260000009159135218182020770_);}\n\t.st9{fill:url(#Rectangle_124_00000070106831554119791940000016334931635183994551_);}\n\t.st10{clip-path:url(#SVGID_00000097484484074030001600000016548138867878612864_);}\n\t.st11{fill:url(#Rectangle_125_00000163048784736025031610000007912380472896111037_);}\n\t.st12{clip-path:url(#SVGID_00000148648677321980391550000004918269968652193925_);}\n\t.st13{fill:url(#Rectangle_126_00000156572648220753620240000017831517147207286163_);}\n\t.st14{clip-path:url(#SVGID_00000031930505338675628130000009328373327174326698_);}\n\t.st15{fill:url(#Rectangle_128_00000023265219967704383450000002768072547960955035_);}\n\t.st16{clip-path:url(#SVGID_00000048462374845426406430000012294030512436377243_);}\n\t.st17{fill:url(#Rectangle_130_00000127003805199776336310000015205885970701854594_);}\n\t.st18{clip-path:url(#SVGID_00000127755502741109701390000012821685719622686350_);}\n\t.st19{fill:url(#Rectangle_132_00000133508895204352297100000012589428136731083172_);}\n\t.st20{clip-path:url(#SVGID_00000120529148210017550230000005738157495236495796_);}\n\t.st21{fill:url(#Rectangle_133_00000136371332849723875190000000367469561997710986_);}\n\t.st22{clip-path:url(#SVGID_00000142886093584808978770000009930778440656905111_);}\n\t.st23{fill:url(#Rectangle_134_00000119808882734879743700000005652834707078354061_);}\n\t.st24{clip-path:url(#SVGID_00000029747869344823248020000011816871266892522634_);}\n\t.st25{fill:url(#Rectangle_135_00000030459897520652556320000014668312738762753979_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    transform: "translate(-283.756 -1361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    transform: "translate(283.756 1361)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "13.5,93.5 27.2,101.9 41.4,94.3 41.9,78.2 28.2,69.7 14,77.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183952772878629075650000002402382779149752716_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    style: {
      clipPath: "url(#SVGID_00000183952772878629075650000002402382779149752716_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_120_00000155138760137159466350000016172856139243888035_",
    gradientUnits: "userSpaceOnUse",
    x1: -171.9375,
    y1: 297.8091,
    x2: -171.9224,
    y2: 297.8091,
    gradientTransform: "matrix(47.2705 -19.7174 -20.775 -49.806 14316.6768 11539.0098)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56CC95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#339A81"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_120",
    style: {
      fill: "url(#Rectangle_120_00000155138760137159466350000016172856139243888035_)"
    },
    points: " 2.1,74.5 37.7,59.6 53.3,97.2 17.7,112  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    transform: "translate(283.756 1361)"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000077282729264051445540000009032646307116574644_",
    points: "0.1,75.7 0,79.2 3,81.1 6.1,79.4 6.2,75.9  3.2,74  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000084507423826878226050000008769966765417412762_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077282729264051445540000009032646307116574644_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    style: {
      clipPath: "url(#SVGID_00000084507423826878226050000008769966765417412762_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_121_00000147940580713704517720000015747140399245219757_",
    gradientUnits: "userSpaceOnUse",
    x1: -165.1127,
    y1: 282.8846,
    x2: -165.0457,
    y2: 282.8846,
    gradientTransform: "matrix(10.3949 -4.3361 -4.5687 -10.9523 3008.9639 2461.0442)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56CC95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#339A81"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_121",
    style: {
      fill: "url(#Rectangle_121_00000147940580713704517720000015747140399245219757_)"
    },
    points: " -2.5,75.1 5.3,71.8 8.8,80 0.9,83.3  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    transform: "translate(283.756 1361)"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000130619766633963429000000001577158237509190573_",
    points: "1.9,48.3 10.4,44.6 17.8,50.1 16.8,59.2  8.3,62.9 0.9,57.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008117186844840061940000011277605959104457655_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130619766633963429000000001577158237509190573_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    style: {
      clipPath: "url(#SVGID_00000008117186844840061940000011277605959104457655_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_122_00000010307307334044924800000005308047311326655128_",
    gradientUnits: "userSpaceOnUse",
    x1: -170.4707,
    y1: 294.4317,
    x2: -170.4458,
    y2: 294.4317,
    gradientTransform: "matrix(27.7712 -11.5839 -11.9793 -28.7191 8261.9883 6538.4707)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56CC95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#339A81"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_122",
    style: {
      fill: "url(#Rectangle_122_00000010307307334044924800000005308047311326655128_)"
    },
    points: " -5.6,47.3 15.3,38.6 24.3,60.2 3.4,68.9  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    transform: "translate(283.756 1361)"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000169523465880326369620000004532207983378658204_",
    points: "34,49.1 52.5,33.7 43.5,11.4 19.6,13  13.7,36.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083793969270446172280000003502939907531311253_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169523465880326369620000004532207983378658204_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    style: {
      clipPath: "url(#SVGID_00000083793969270446172280000003502939907531311253_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_123_00000018936332210598189790000009362412008959463064_",
    gradientUnits: "userSpaceOnUse",
    x1: -172.4158,
    y1: 298.3098,
    x2: -172.4045,
    y2: 298.3098,
    gradientTransform: "matrix(61.6841 -25.7295 -25.4258 -60.9558 18222.6191 13790.498)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56CC95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#339A81"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_123",
    style: {
      fill: "url(#Rectangle_123_00000018936332210598189790000009362412008959463064_)"
    },
    points: " 0.3,17 46.7,-2.4 65.9,43.5 19.4,62.9  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    transform: "translate(283.756 1361)"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000083077238967997086110000006459541240029273984_",
    points: "51.2,71 58,68.9 58,61.8 51.2,59.5 47.1,65.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000213804499546036410000011758721377078586007_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083077238967997086110000006459541240029273984_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    style: {
      clipPath: "url(#SVGID_00000000213804499546036410000011758721377078586007_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_124_00000111173361914694642660000002087499686069635255_",
    gradientUnits: "userSpaceOnUse",
    x1: -171.8441,
    y1: 290.5362,
    x2: -171.805,
    y2: 290.5362,
    gradientTransform: "matrix(17.769 -7.4122 -7.5639 -18.1326 5255.1182 4079.9531)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56CC95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#339A81"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_124",
    style: {
      fill: "url(#Rectangle_124_00000111173361914694642660000002087499686069635255_)"
    },
    points: " 43,61.2 56.4,55.7 62.1,69.3 48.7,74.9  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    transform: "translate(283.756 1361)"
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000101097125368652434160000005185299331055427221_",
    points: "57.1,51 57.1,46.8 53,45.4 50.5,48.9 53,52.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093150004559361893290000006428443334446676649_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101097125368652434160000005185299331055427221_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    style: {
      clipPath: "url(#SVGID_00000093150004559361893290000006428443334446676649_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_125_00000058587706773640832030000010160794660183894927_",
    gradientUnits: "userSpaceOnUse",
    x1: -171.3416,
    y1: 282.6228,
    x2: -171.2769,
    y2: 282.6228,
    gradientTransform: "matrix(10.6911 -4.4597 -4.5521 -10.9126 3122.5034 2389.6201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56CC95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#339A81"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_125",
    style: {
      fill: "url(#Rectangle_125_00000058587706773640832030000010160794660183894927_)"
    },
    points: " 48,46.5 56.1,43.1 59.5,51.3 51.5,54.7  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    transform: "translate(283.756 1361)"
  }, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000126291400144611890140000016671659731754372522_",
    x: 72.7,
    y: 2.9,
    transform: "matrix(0.9468 -0.3219 0.3219 0.9468 9.103648e-02 27.5352)",
    width: 21.1,
    height: 21.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062906816613161553130000006289804826490221233_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000126291400144611890140000016671659731754372522_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    style: {
      clipPath: "url(#SVGID_00000062906816613161553130000006289804826490221233_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_126_00000043430066036082691910000010620063315718377618_",
    gradientUnits: "userSpaceOnUse",
    x1: -173.5738,
    y1: 296.8442,
    x2: -173.5579,
    y2: 296.8442,
    gradientTransform: "matrix(42.9915 -17.9335 -17.9335 -42.9915 12792.0967 9694.5547)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56CC95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#339A81"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_126",
    style: {
      fill: "url(#Rectangle_126_00000043430066036082691910000010620063315718377618_)"
    },
    points: " 60.4,4.1 92.7,-9.5 106.2,22.9 73.9,36.4  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    transform: "translate(283.756 1361)"
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000102514805458203055330000004280671761424853150_",
    x: 77.7,
    y: 34.8,
    transform: "matrix(0.8051 -0.5931 0.5931 0.8051 -7.6065 57.1098)",
    width: 10.7,
    height: 10.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128457986712111780140000005987064559948167823_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000102514805458203055330000004280671761424853150_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    style: {
      clipPath: "url(#SVGID_00000128457986712111780140000005987064559948167823_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_128_00000060716365804288812980000005066908160710137270_",
    gradientUnits: "userSpaceOnUse",
    x1: -173.8183,
    y1: 293.196,
    x2: -173.7897,
    y2: 293.196,
    gradientTransform: "matrix(24.0829 -10.0454 -10.0454 -24.0829 7137.7344 5387.0649)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56CC95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#339A81"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_128",
    style: {
      fill: "url(#Rectangle_128_00000060716365804288812980000005066908160710137270_)"
    },
    points: " 70.3,34.8 88.4,27.3 96,45.4 77.8,53  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    transform: "translate(283.756 1361)"
  }, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000063605117567404980860000009000193968929826205_",
    x: 63,
    y: 30.9,
    transform: "matrix(0.9878 -0.1557 0.1557 0.9878 -4.57 10.8016)",
    width: 7.3,
    height: 7.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000024708273235544397470000016036253668397743283_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000063605117567404980860000009000193968929826205_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    style: {
      clipPath: "url(#SVGID_00000024708273235544397470000016036253668397743283_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_130_00000075141434285371192820000010459532331949068473_",
    gradientUnits: "userSpaceOnUse",
    x1: -172.9739,
    y1: 286.045,
    x2: -172.9219,
    y2: 286.045,
    gradientTransform: "matrix(13.4285 -5.6016 -5.6016 -13.4285 3930.2219 2932.4546)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56CC95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#339A81"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_130",
    style: {
      fill: "url(#Rectangle_130_00000075141434285371192820000010459532331949068473_)"
    },
    points: " 59.5,31.6 69.6,27.4 73.8,37.5 63.7,41.7  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    transform: "translate(283.756 1361)"
  }, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000179607035252348805700000004602882082026414255_",
    points: "107,41.7 115.9,29.2 100.7,27.8  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005234020339533384390000008463156226627639433_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179607035252348805700000004602882082026414255_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    style: {
      clipPath: "url(#SVGID_00000005234020339533384390000008463156226627639433_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_132_00000046326178476885996180000008078498181050971311_",
    gradientUnits: "userSpaceOnUse",
    x1: -175.1281,
    y1: 292.8087,
    x2: -175.0988,
    y2: 292.8087,
    gradientTransform: "matrix(23.7615 -9.9119 -9.5519 -22.8986 6966.5547 5045.457)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56CC95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#339A81"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_132",
    style: {
      fill: "url(#Rectangle_132_00000046326178476885996180000008078498181050971311_)"
    },
    points: " 95.7,29.8 113.6,22.4 120.8,39.6 102.9,47.1  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    transform: "translate(283.756 1361)"
  }, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000034800646211424336640000017532704071856535208_",
    points: "136.7,25.1 150,9.8 130.1,6  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000138535866445789920520000008633882436311884980_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034800646211424336640000017532704071856535208_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    style: {
      clipPath: "url(#SVGID_00000138535866445789920520000008633882436311884980_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_133_00000079453039999050361710000013324835440514849968_",
    gradientUnits: "userSpaceOnUse",
    x1: -175.9084,
    y1: 295.1327,
    x2: -175.8865,
    y2: 295.1327,
    gradientTransform: "matrix(31.5241 -13.1493 -12.9414 -31.0257 9375.5723 6913.124)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56CC95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#339A81"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_133",
    style: {
      fill: "url(#Rectangle_133_00000079453039999050361710000013324835440514849968_)"
    },
    points: " 123.3,8.8 147.1,-1.1 156.8,22.3 133.1,32.2  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    transform: "translate(283.756 1361)"
  }, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000072266076173467064570000004345068727352502919_",
    points: "119.5,19 120.4,10 112.1,13.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044872568329496545540000016635120341566570157_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072266076173467064570000004345068727352502919_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    style: {
      clipPath: "url(#SVGID_00000044872568329496545540000016635120341566570157_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_134_00000062164525064955067450000007289457751344328601_",
    gradientUnits: "userSpaceOnUse",
    x1: -177.5243,
    y1: 286.8228,
    x2: -177.4731,
    y2: 286.8228,
    gradientTransform: "matrix(13.6281 -5.6845 -5.8855 -14.1099 4116.3604 3097.1882)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56CC95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#339A81"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_134",
    style: {
      fill: "url(#Rectangle_134_00000062164525064955067450000007289457751344328601_)"
    },
    points: " 108.9,11.4 119.2,7.1 123.6,17.7 113.3,22  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    transform: "translate(283.756 1361)"
  }, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000123427766887252718010000000970299148658606264_",
    points: "143.6,48.8 145.6,31.1 129.3,38.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114060175947031082750000004058738608076222129_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123427766887252718010000000970299148658606264_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    style: {
      clipPath: "url(#SVGID_00000114060175947031082750000004058738608076222129_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_135_00000078752432054243894920000017636411950461533627_",
    gradientUnits: "userSpaceOnUse",
    x1: -176.1849,
    y1: 294.5561,
    x2: -176.1593,
    y2: 294.5561,
    gradientTransform: "matrix(26.7841 -11.1727 -11.5539 -27.6978 8132.8257 6282.9175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56CC95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#339A81"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_135",
    style: {
      fill: "url(#Rectangle_135_00000078752432054243894920000017636411950461533627_)"
    },
    points: " 123,33.7 143.2,25.3 151.9,46.1 131.7,54.5  "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreestandingProductsGraphic);
export default __webpack_public_path__ + "static/media/freestanding-products-graphic.0a22a971a61ba024b3a4a89c5dfadfce.svg";
export { ForwardRef as ReactComponent };